import React, { useState } from "react";
import { Grid, MenuItem, TextField } from "@mui/material";
import moment from "moment/moment";

import { getToken } from "../../../../api/Account";
import { addVacacionesAsync } from "../../../../api/Employees";
import { useAviso } from "../../../../components/base";
import {
  CampoFecha,
  DialogoFormulario,
  fechaCambiada,
  useEnvio,
  useEscritura,
} from "../comunes";

const AddVacaciones = ({ id, setShowModal, reload, setReload }) => {
  const [motivo, setMotivo] = useState("");
  const [desde, setDesde] = useState(new Date());
  const [hasta, setHasta] = useState(new Date());
  const [selectedTVacaciones, setSelectedTVacaciones] = useState(0);
  const [intentado, setIntentado] = useState(false);

  const token = getToken();
  const aviso = useAviso();
  const escribir = useEscritura();
  const { guardando, enviar } = useEnvio();

  // Las reglas de siempre: descripción vacía y fechas válidas. El tipo 0 ("Seleccione…") y el
  // rango de fechas no se validan (B15, se proponen aparte).
  const errores = {};
  if (motivo.length === 0) errores.motivo = "Ingrese una descripción";
  if (!moment(desde).isValid()) errores.desde = "Seleccione una fecha válida";
  if (!moment(hasta).isValid()) errores.hasta = "Seleccione una fecha válida";

  const saveChanges = () =>
    enviar(async () => {
      setIntentado(true);
      if (Object.keys(errores).length > 0) return;

      const data = {
        employeeId: id,
        motivo,
        desde: moment(desde).format("YYYY-MM-DD"),
        hasta: moment(hasta).format("YYYY-MM-DD"),
        pagadas: selectedTVacaciones,
      };

      const ok = await escribir(
        () => addVacacionesAsync(token, data),
        "No se pudieron agregar las vacaciones"
      );
      if (!ok) return;
      aviso.exito("Vacaciones agregadas");
      setReload(!reload);
      setShowModal(false);
    });

  const mostrar = intentado ? errores : {};

  return (
    <DialogoFormulario
      titulo="Agregar vacaciones"
      onCerrar={() => setShowModal(false)}
      hayCambios={
        motivo !== "" ||
        selectedTVacaciones !== 0 ||
        fechaCambiada(desde) ||
        fechaCambiada(hasta)
      }
      guardando={guardando}
      onEnviar={saveChanges}
      textoEnviar="Agregar vacaciones"
    >
      <Grid container spacing={2} sx={{ pt: 1 }}>
        <Grid item xs={12}>
          <TextField
            autoFocus
            required
            fullWidth
            label="Descripción"
            value={motivo}
            onChange={(e) => setMotivo(e.target.value.toUpperCase())}
            error={Boolean(mostrar.motivo)}
            helperText={mostrar.motivo || " "}
            disabled={guardando}
            inputProps={{ autoComplete: "off" }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CampoFecha
            label="Inicio"
            value={desde}
            onChange={(newValue) => setDesde(newValue)}
            error={mostrar.desde}
            disabled={guardando}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CampoFecha
            label="Retorno"
            value={hasta}
            onChange={(newValue) => setHasta(newValue)}
            error={mostrar.hasta}
            disabled={guardando}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            select
            fullWidth
            label="Tipo de vacaciones"
            value={selectedTVacaciones}
            onChange={(e) => setSelectedTVacaciones(e.target.value)}
            helperText=" "
            disabled={guardando}
          >
            <MenuItem value={0}>
              <em>Seleccione un tipo de vacaciones</em>
            </MenuItem>
            <MenuItem key={1} value={1}>
              PAGADAS
            </MenuItem>
            <MenuItem key={2} value={2}>
              NO PAGADAS
            </MenuItem>
          </TextField>
        </Grid>
      </Grid>
    </DialogoFormulario>
  );
};

export default AddVacaciones;
